export default [
  {
    path: "/manage-clients",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/manage-clients",
        name: "manage-clients",
        component: () => import("./ClientCustomerManager.vue"),
      },
    ],
  },
];
